import { Dropdown } from 'antd';
import FileMenu from './FileMenu';
import DataNode from '../../../../interfaces/dataRoom/dataNode';
import { MenuInfo } from 'rc-menu/lib/interface';
import UpdatedDate from './UpdatedDate';
import { useMemo } from 'react';
export interface FilePreview {
  name: string;
  url: string;
  type: string;
}

const File = ({
  item,
  onFileNameChange,
  onPreview,
  isMobile,
  filesize,
  onClick,
  menu,
}: {
  item: DataNode;
  onFileNameChange: (name: string) => void;
  onPreview: (file: FilePreview) => void;
  isMobile: boolean;
  filesize: (size: number) => string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  menu;
}) => {
  const resolveFileExtension = (fileName: string): string => {
    var slipt = fileName.split('.');

    if (slipt[slipt.length - 1] === fileName) {
      return '';
    }

    return slipt[slipt.length - 1];
  };
  const ids = useMemo(() => {
    if (!item?.id) {
      return [];
    }
    return [item?.id];
  }, [item?.id]);
  return (
    <div
      className="d-flex justify-content-space-between"
      onClick={() => {
        onFileNameChange(item.name);
      }}
    >
      <span
        onDoubleClick={() => {
          onPreview({
            name: item.name,
            url: item.url,
            type: resolveFileExtension(item.name),
          });
        }}
      >
        <span>
          {item.name.length > 30 ? `${item.name.slice(0, 30)}...` : item.name}
        </span>
      </span>
      {!isMobile && (
        <div
          className="d-flex align-items-center"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <span className="mr-10">{item.createdBy}</span>
          <span className="data-room__first-node-info-size">
            {filesize(item.size)}
          </span>
          <span className="mr-50">
            <UpdatedDate>{item.createdDate}</UpdatedDate>
          </span>
          <Dropdown.Button
            className="context-menu"
            onClick={onClick}
            overlay={menu}
          ></Dropdown.Button>
        </div>
      )}
    </div>
  );
};

export default File;
